<template>
    <div>
        <div v-if="!searchError && !loading">
            <a
                v-for="(item, index) in news" :key="index"
                :href="item.attributes.path"
                class="press-article"
                :class="{'_mb-0': index === news.length-1 }"
            >
                <div class="press-item">
                    <div>
                        <div class="_dflex _flexwrap">
                            <a
                                v-for="tag in item.attributes.sections"
                                :key="tag.code" href="#"
                                class="press-item__tag"
                                @click.prevent="filterTag(tag.code)"
                            >
                                {{ tag.name }}
                            </a>
                        </div>
                        <h4 class="h4 _mt-8" v-html="item.attributes.name"></h4>
                    </div>
                    <div class="_dflex _justify-content-between _mt-16">
                        <div class="_dflex _align-items-center p2 gray-text-light">
                            <img class="press-item__icon press-item__icon_min" src="/local/templates/redesign/src/assets/img/press/calendar.svg" />
                            <time class="_ml-8">{{ item.attributes.activeFrom }}</time>
                        </div>
                        <!-- <div><img class="press-item__icon" src="/local/templates/redesign/src/assets/img/press/arrow.svg" /></div> -->
                    </div>
                </div>
            </a>
            <a @click.prevent="getMoreNews" href="#" class="button _mt-32-24 button_light" v-show="showMoreButton && news">Показать ещё</a>
        </div>
        <div v-if="searchError">
            <div class="p1 press-no-result">
                <div class="_mobile-visible-flx _justify-content-center"><img class="press-no-result__image" src="/local/templates/redesign/src/assets/img/press/error.webp" /></div>
                <div class="press-no-result__content">
                    <h4 class="h4">Проверьте, правильно ли введен запрос</h4>
                    <p class="p1 _mt-12 text-grey-517">Измените фильтры или выберите другой поисковой запрос</p>
                </div>
                <img class="press-no-result__image _mobile-hidden" src="/local/templates/redesign/src/assets/img/press/error.webp" />
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import { onBeforeMount, computed } from 'vue';
    import { useStore } from '../../store';
    import { showMoreCheckout } from './services/showMoreCheckout';
    import { getNews } from './services/getNews';
    import { getUrl } from './services/getUrl';
    import { filter } from './services/filter';

    export default {
        name: "pressNews",
        props: {
            items: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        setup(props) {
            const store = useStore();

            const filterTag = (val) => {
                filter(val);
            }

            let news = computed(() => {
                return store.state.press.news;
            });

            let loading = computed(() => {
                return store.state.press.loading;
            });

            let searchError = computed(() => {
                return store.state.press.searchError;
            });

            let showMoreButton = computed(() => {
                return store.state.press.showMoreButton;
            });

            const getMoreNews = () => {
                store.commit('press/SET_LOADING', true);
                let url = getUrl();

                axios.get(url)
                    .then(res => {
                        showMoreCheckout(res.data.meta.totalPages);
                        const articles = !store.state.press.news.length ? res.data.data : [...store.state.press.news, ...res.data.data];
                        store.commit('press/SET_NEWS', articles);
                        store.commit('press/SET_LOADING', false);
                    })
            }

            const checkUrlProduct = () => {
                if (location.pathname !== '/press/' && location.pathname !== '/press/media-about-us/') {
                    props.items.forEach(element => {
                        if (location.pathname.indexOf(element.code) !== -1) {
                            store.commit('press/CHANGE_FILTER', element.code);
                            filter(store.state.press.filterCode);
                        }
                    });
                }
                else {
                    getNews();
                }
            }

            onBeforeMount(() => {
                store.commit('press/SET_PAGE_NUMBER', 1);
                checkUrlProduct();
            })

            return {
                news,
                loading,
                searchError,
                showMoreButton,
                filterTag,
                checkUrlProduct,
                getMoreNews
            };
        },
    }
</script>
